function ruleToText(scope) {
  return ({ selector, value }) => `${scope} ${selector}{${value}}`;
}

function normalizeRules(attrs) {
  if (!attrs) return false;
  const rules = Object.keys(attrs).map(attr => `${attr}: ${attrs[attr]};`);
  return rules.join(' ');
}

class StyleSheet {
  constructor(id = '') {
    this.html = document.createElement('style');
    this.html.id = id;
    this.ruleCreator = ruleToText('[kjuicer-component-root]');

    this.update = this.update.bind(this);
    this.ruleIndex = this.ruleIndex.bind(this);
    this.createRule = this.createRule.bind(this);
    this.updateRule = this.updateRule.bind(this);

    this.rules = [];
  }

  get sheet() {
    return this.html.sheet;
  }

  ruleIndex(rule) {
    return this.rules.reduce((prev, curr, i) => {
      if (curr.selector === rule.selector) {
        return i;
      }
      return prev;
    }, -1);
  }

  createRule(rule) {
    const index = this.rules.push(rule) - 1;
    this.sheet.insertRule(this.ruleCreator(rule), index);
    return index;
  }

  updateRule(rule, index) {
    if (this.rules[index].value !== rule.value) {
      this.rules[index].value = rule.value;
      this.sheet.deleteRule(index);
      this.sheet.insertRule(this.ruleCreator(rule), index);
    }

    return index;
  }

  deleteRule(rule, index) {
    this.sheet.deleteRule(index);
    this.rules.splice(index, 1);
  }

  update(rules) {
    Object.keys(rules).map((key) => {
      const rule = { selector: key, value: normalizeRules(rules[key]) };
      const index = this.ruleIndex(rule);
      if (index >= 0 && rule.value) {
        this.updateRule(rule, index);
      } else if (index < 0 && rule.value) {
        this.createRule(rule);
      } else if (index >= 0 && !rule.value) {
        this.deleteRule(rule, index);
      }

      return rule;
    });
  }
}

export default StyleSheet;
